<template>
  <v-snackbar v-model="show" :timeout="5000" top right :color="type">
    {{ message }}
    <template v-slot:action="{ attrs }">
      <v-icon
        left
        color="#fff"
        v-bind="attrs"
        @click.native="show = false"
        style="cursor: pointer"
      >
        highlight_off
      </v-icon>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: "",
      type: ""
    };
  },
  created: function() {
    this.$store.watch(
      state => state.user.snack,
      () => {
        const msg = this.$store.state.user.snack;
        const type = this.$store.state.user.type;
        if (msg !== "") {
          this.show = true;
          this.message = msg;
          this.type = type;
          this.$store.dispatch("user/setSnack", "");
          this.$store.dispatch("user/setType", "");
        }
      }
    );
  }
};
</script>

<style scoped>    
    ::v-deep .v-snack__wrapper {
        min-width: 0px !important;
        max-width: 400px !important;
    }
</style>
